import camelCaseKeys from "camelcase-keys";
import * as z from "zod";

import { authorizedGet } from "../../authorizedRequests";

export const PaymentSchema = z.object({
  id: z.number(),
  taxInclusive: z.string(),
});
export type Payment = z.infer<typeof PaymentSchema>;

export const CheckoutSessionSchema = z.object({
  uuid: z.string(),
  originatorId: z.string(),
  originatorType: z.union([
    z.literal("CustomerTab"),
    z.literal("OrderCart::Cart"),
  ]),
});
export type CheckoutSession = z.infer<typeof CheckoutSessionSchema>;

export const fetchCheckoutSession = async (
  uuid: string,
): Promise<CheckoutSession> => {
  const response = await authorizedGet({
    url: `/v1/checkout_sessions/${uuid}`,
  });
  const responseData = camelCaseKeys(response.body.checkout_session, {
    deep: true,
  });

  return CheckoutSessionSchema.parse(responseData);
};
